import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Card, CardBody, CardFooter,Row, Col, Progress, Table, Badge,Nav,NavItem, TabContent,TabPane,NavLink} from "reactstrap";
import {Bar, Line} from "react-chartjs-2";
import classNames from 'classnames';
import {mapToCssModules} from 'reactstrap/lib/utils';
import classnames from "classnames";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

const propTypes = {
    header: PropTypes.string,
    mainText: PropTypes.string,
    icon: PropTypes.string,
    color: PropTypes.string,
    variant: PropTypes.string,
    footer: PropTypes.bool,
    link: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    cssModule: PropTypes.object,
    systemVoltage: PropTypes.number,
    MeterPfRot: PropTypes.number,
    MeterPf: PropTypes.number,
    MeterAmpsA: PropTypes.number,
    MeterAmpsB: PropTypes.number,
    MeterAmpsC: PropTypes.number,
    MeterFreqRef: PropTypes.number,
    MeterVoltsAB: PropTypes.number,
    MeterVoltsBC: PropTypes.number,
    MeterVoltsCA: PropTypes.number,
    MeterVoltsRef: PropTypes.number,
    MeterVoltsKw: PropTypes.number,
    MeterVoltsKvar: PropTypes.number,
    MeterFreq: PropTypes.number,
    MeterPhaAngleDiff: PropTypes.number,
    WarmupTimer: PropTypes.number,
    StatusAndControl: PropTypes.number,
    EngineOilPress: PropTypes.number,
    EngineCoolantTemp: PropTypes.number,
    EngineBoostPress: PropTypes.number,
    EngineRPM: PropTypes.number,
    EngineBattVolts: PropTypes.number,
    EngineFuelPress: PropTypes.number,
    EngineCrankcasePress: PropTypes.number,
    EngineOilDiffPress: PropTypes.number,
    EngineFuelDiffPress: PropTypes.number,
    EngineAtmosphericPress: PropTypes.number,
    EngineIntakeAirDiffPress: PropTypes.number,
    EngineFuelConsumption: PropTypes.number,
    EngineLeftExhaustTemp: PropTypes.number,
    EngineRightExhaustTemp: PropTypes.number,
    breakerAux: PropTypes.number

};

const defaultProps = {
    header: '$1,999.50',
    mainText: 'Income',
    icon: "fa fa-cogs",
    color: 'primary',
    variant: "0",
    link: "#",
    systemVoltage:480,
    MeterPfRot: 0,
    MeterPf: 0,
    MeterAmpsA: 0,
    MeterAmpsB: 0,
    MeterAmpsC: 0,
    MeterFreqRef: 0,
    MeterVoltsAB: 0,
    MeterVoltsBC: 0,
    MeterVoltsCA: 0,
    MeterVoltsRef: 0,
    MeterVoltsKw: 0,
    MeterVoltsKvar: 0,
    MeterFreq: 0,
    MeterPhaAngleDiff: 0,
    WarmupTimer: 0,
    StatusAndControl: 0,
    EngineOilPress: 0,
    EngineCoolantTemp: 0,
    EngineBoostPress: 0,
    EngineRPM: 0,
    EngineBattVolts: 0,
    EngineFuelPress: 0,
    EngineCrankcasePress: 0,
    EngineOilDiffPress: 0,
    EngineFuelDiffPress: 0,
    EngineAtmosphericPress: 0,
    EngineIntakeAirDiffPress: 0,
    EngineFuelConsumption: 0,
    EngineLeftExhaustTemp: 0,
    EngineRightExhaustTemp: 0,
    breakerAux: false

};

// Card Chart 1
const cardChartData1 = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
        {
            label: 'My First dataset',
            backgroundColor: brandPrimary,
            borderColor: 'rgba(255,255,255,.55)',
            data: [65, 59, 84, 84, 51, 55, 40]
        }
    ],
};

const cardChartOpts1 = {
    maintainAspectRatio: false,
    legend: {
        display: false
    },
    scales: {
        xAxes: [{
            gridLines: {
                color: 'transparent',
                zeroLineColor: 'transparent'
            },
            ticks: {
                fontSize: 2,
                fontColor: 'transparent',
            }

        }],
        yAxes: [{
            display: false,
            ticks: {
                display: false,
                min: Math.min.apply(Math, cardChartData1.datasets[0].data) - 5,
                max: Math.max.apply(Math, cardChartData1.datasets[0].data) + 5,
            }
        }],
    },
    elements: {
        line: {
            borderWidth: 1
        },
        point: {
            radius: 4,
            hitRadius: 10,
            hoverRadius: 4,
        },
    }
}


class Generators extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: '1'
        };
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
    render() {
        const {systemVoltage, MeterPfRot,
            MeterPf,
            MeterAmpsA,
            MeterAmpsB,
            MeterAmpsC,
            MeterFreqRef,
            MeterVoltsAB,
            MeterVoltsBC,
            MeterVoltsCA,
            MeterVoltsRef,
            MeterVoltsKw,
            MeterVoltsKvar,
            MeterFreq,
            MeterPhaAngleDiff,
            WarmupTimer,
            StatusAndControl,
            EngineOilPress,
            EngineCoolantTemp,
            EngineBoostPress,
            EngineRPM,
            EngineBattVolts,
            EngineFuelPress,
            EngineCrankcasePress,
            EngineOilDiffPress,
            EngineFuelDiffPress,
            EngineAtmosphericPress,
            EngineIntakeAirDiffPress,
            EngineFuelConsumption,
            EngineLeftExhaustTemp,
            EngineRightExhaustTemp,
            breakerAux
            , className, cssModule, header, mainText, icon, color, footer, link, children, variant, ...attributes} = this.props;

        // demo purposes only
        const padding = (variant === '0' ? {card: "p-3", icon: "p-3", lead: "mt-2"} : ( variant === "1" ? {
            card: "p-0", icon: "p-4", lead: "pt-3" } : {card: "p-0", icon: "p-4 px-5", lead: "pt-3"}));

        const card = {style: "card-body clearfix", color: color, icon: icon, classes: ""};
        card.classes = mapToCssModules(classNames(className, card.style, padding.card), cssModule);

        const lead = {style: "h5 mb-0", color: color, classes: ""};
        lead.classes = classNames(lead.style, 'text-black-50', padding.lead);

        const blockIcon = function (icon) {
            const classes = classNames(icon, 'bg-light', padding.icon, "font-2xl mr-3 float-left");
            return (<i className={ classes }></i>);
        };

        const cardFooter = function () {
            if (footer) {
                return (
                    <CardFooter className="px-3 py-2">
                        <a className="font-weight-bold font-xs btn-block text-muted" href={link}>View More
                            <i className="fa fa-angle-right float-right font-lg"></i></a>
                    </CardFooter>
                );
            }
        };
        return (
            <Card>
                <CardBody className={ card.classes } {...attributes}>
                    { blockIcon(card.icon) }
                    <div className={ lead.classes }>{ header }</div>
                    <div className="text-muted text-uppercase font-weight-bold font-xs">{ mainText }</div>
                    <hr />
                    <Row>
                        <Col xs="6" sm="6" lg="6">
                            <div className="text-muted text-uppercase font-weight-normal font-xs">Breaker</div>
                        </Col>
                        <Col xs="6" sm="6" lg="6">
                            <div>{breakerAux ? <Badge color="danger">Closed</Badge> : <Badge color="success">Open</Badge> }</div>
                        </Col>
                    </Row>
                    <hr />
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === '1' })}
                                onClick={() => { this.toggle('1'); }}
                            >
                                Metering
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === '2' })}
                                onClick={() => { this.toggle('2'); }}
                            >
                                Engine
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="1">
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Voltage AB</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ MeterVoltsAB }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Voltage BC</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ MeterVoltsBC }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Voltage CA</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ MeterVoltsCA }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Amps A</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ MeterAmpsA }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Amps B</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ MeterAmpsB }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Amps C</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ MeterAmpsC }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Freq</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ MeterFreq / 100 }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Kw</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ MeterVoltsKw }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Kvar</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ MeterVoltsKvar }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Pf</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ MeterPf }</div>
                                </Col>
                            </Row>
                            <hr />
                        </TabPane>
                        <TabPane tabId="2">
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Oil Press</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ EngineOilPress }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Coolant Temp</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ EngineCoolantTemp }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Boost Press</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ EngineBoostPress }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">RPM</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ EngineRPM }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Battery</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ EngineBattVolts }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Fuel Press</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ EngineFuelPress }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Crankcase Press</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ EngineCrankcasePress }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Oil Diff Press</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ EngineOilDiffPress }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Fuel Diff Press</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ EngineFuelDiffPress }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Atmospheric Press</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ EngineAtmosphericPress }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Intake Diff Press</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ EngineIntakeAirDiffPress }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Fuel Consumption</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ EngineFuelConsumption }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Left Exhaust Temp</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ EngineLeftExhaustTemp }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Right Exhaust Temp</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ EngineRightExhaustTemp }</div>
                                </Col>
                            </Row>
                        </TabPane>
                    </TabContent>

                </CardBody>
                { cardFooter() }
            </Card>
        )
    }
}

Generators.propTypes = propTypes;
Generators.defaultProps = defaultProps;

export default Generators;


// WEBPACK FOOTER //
// ./src/views/site/GeneratorSchema/Generators.js